import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Firma_ElectronicaService } from 'src/app/services/firma_electronica.service';
import { Expedientes_Lista } from 'src/app/models/generic/Expedientes_Lista';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { ExpedientesService } from 'src/app/services/expedientes.service';
import { ProductosService } from 'src/app/services/productos.service';
import { TopAfiliadosResumen } from 'src/app/models/generic/TopAfiliadosResumen';
import { Expedientes_Top_DTO } from 'src/app/models/generic/TopExpedientesResumen';

@Component({
  selector: 'expedientes',
  templateUrl: './expedientes.component.html',
  styleUrls: ['./expedientes.component.scss']
})
export class ExpedientesComponent implements OnInit{
  ESTADOS_NUEVO: string = 'A';
  ESTADOS_PROCESO: string = 'P';
  ESTADOS_SEGUIMIENTO: string = 'S';
  ESTADOS_TERMINADO: string = 'T';

  @Input() mostrarBotonRegresar: boolean = true;

  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild('paginatorNuevos') paginatorNuevos: MatPaginator;
  @ViewChild('paginatorProceso') paginatorProceso: MatPaginator;
  @ViewChild('paginatorSeguimiento') paginatorSeguimiento: MatPaginator;
  @ViewChild('paginatorTerminado') paginatorTerminado: MatPaginator;
  dataSourceNuevos: MatTableDataSource<Expedientes_Lista>;
  dataSourceProceso: MatTableDataSource<Expedientes_Lista>;
  dataSourceSeguimiento: MatTableDataSource<Expedientes_Lista>;
  dataSourceTerminado: MatTableDataSource<Expedientes_Lista>;
  columnasEncabezado: string[] = ['expediente', 'subservicio', 'estado', 'afiliado', 'propietario', 'responsable', 'fecha', 'cola'];
  listaDatos: Expedientes_Lista[] = [];
  itemSeleccionadoFirma: Expedientes_Lista;
  porcentajeTotalMesAnterior: number = 0;
  porcentajeInactivosMesAnterior: number = 0;
  porcentajeExpedientesNuevosMesAnterior: number = 0;
  porcentajeExpedientesConcluidosMesAnterior: number = 0;
  porcentajeExpedientesAsignadosMesAnterior: number = 0;
  descripcionTotalMesAnterior: string = '';
  descripcionInactivosMesAnterior: string = '';
  descripcionExpedientesNuevosMesAnterior: string = '';
  descripcionExpedientesConcluidosMesAnterior: string = '';
  descripcionExpedientesAsignadosMesAnterior: string = '';
  textoBusqueda: string = '';
  mostrarExpedientesNuevos: boolean = true;
  mostrarExpedientesProceso: boolean = true;
  mostrarExpedientesSeguimiento: boolean = true;
  mostrarExpedientesTerminado: boolean = true;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: ExpedientesService,
    public productosService: ProductosService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.Consultar();
    this.cargarResumenAfiliado();
    this.cargarResumenExpedientes();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorNuevos);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorProceso);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorSeguimiento);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorTerminado);

    if (this.utilitariosService.VerificarContieneDatos(this.menuService.ParametrosAdicionales)) {
      this.textoBusqueda = this.menuService.ParametrosAdicionales;
      this.Consultar();
    }
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      filtro: [''],
      idAplicacion: [0],
      idCanal: [0],
    });
  }
  Consultar() {
    this.mostrarCargando = true;
    this.form.get('filtro').setValue(this.textoBusqueda);
    this.form.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    this.form.get('idCanal').setValue(this.autenticacionService.CanalSeleccionado);
    this.datosServices.Consultar(this.form.value)
              .subscribe((resp: Expedientes_Lista[]) =>{
                this.mostrarCargando = false;
                this.listaDatos = resp;
                this.datosServices.ListaExpedientes = resp;
                this.recargarLista();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  cargarResumenAfiliado(mes: number = 0) {
    this.mostrarCargando = true;
    
    let parametrosConsulta = this.fb.group({
      mes: 0,
      idAplicacion: 0,
      canal: ''
    });

    parametrosConsulta.get('mes').setValue(mes);
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    parametrosConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionadoInicial);
    this.productosService.CargarTopAfiliadosResumen(parametrosConsulta.value).subscribe((resp: TopAfiliadosResumen[]) => {
      this.productosService.ListaTopAfiliadosResumen = resp;

      if (this.utilitariosService.VerificarContieneDatosLista(this.productosService.ListaTopAfiliadosResumen)) {
        this.porcentajeTotalMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadTotalPorcentajeFrenteAlAnterior;
        this.porcentajeInactivosMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadInactivosPorcentajeFrenteAlAnterior;

        this.descripcionTotalMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadTotalDescripcion;
        this.descripcionInactivosMesAnterior = this.productosService.ListaTopAfiliadosResumen[0].cantidadInactivosDescripcion;
      }

      this.mostrarCargando = false;
    },
    (error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  cargarResumenExpedientes(mes: number = 0) {
    this.mostrarCargando = true;
    
    let parametrosConsulta = this.fb.group({
      mes: 0,
      idAplicacion: 0,
      canal: ''
    });

    parametrosConsulta.get('mes').setValue(mes);
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    parametrosConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionadoInicial);
    this.datosServices.ConsultarResumen(parametrosConsulta.value).subscribe((resp: Expedientes_Top_DTO[]) => {

      if (this.utilitariosService.VerificarContieneDatosLista(resp)) {
        this.porcentajeExpedientesNuevosMesAnterior = resp[0].cantidadNuevosRespectoAnteriorActual;
        this.porcentajeExpedientesConcluidosMesAnterior = resp[0].cantidadConcluidosRespectoAnteriorActual;
        this.porcentajeExpedientesAsignadosMesAnterior = resp[0].cantidadAsignadosRespectoAnteriorActual;

        this.descripcionExpedientesNuevosMesAnterior = resp[0].cantidadNuevosDescripcion;
        this.descripcionExpedientesConcluidosMesAnterior = resp[0].cantidadConcluidosDescripcion;
        this.descripcionExpedientesAsignadosMesAnterior = resp[0].cantidadAsignadosDescripcion;
      }

      this.mostrarCargando = false;
    },
    (error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  ColorPorcentajeTotalMesAnterior(): string {
    if (this.porcentajeTotalMesAnterior > 0) {
      return '#67CB9E';
    } else {
      return '#BF0D3E';
    }
  }
  ColorPorcentajeInactivosMesAnterior(): string {
    if (this.porcentajeInactivosMesAnterior > 0) {
      return '#67CB9E';
    } else {
      return '#BF0D3E';
    }
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  recargarLista() {
    this.dataSourceNuevos = new MatTableDataSource(this.listaDatos.filter(x => x.codigoEstado === this.ESTADOS_NUEVO));
    this.dataSourceNuevos.paginator = this.paginatorNuevos;

    this.dataSourceProceso = new MatTableDataSource(this.listaDatos.filter(x => x.codigoEstado === this.ESTADOS_PROCESO));
    this.dataSourceProceso.paginator = this.paginatorProceso;

    this.dataSourceSeguimiento = new MatTableDataSource(this.listaDatos.filter(x => x.codigoEstado === this.ESTADOS_SEGUIMIENTO));
    this.dataSourceSeguimiento.paginator = this.paginatorSeguimiento;

    this.dataSourceTerminado = new MatTableDataSource(this.listaDatos.filter(x => x.codigoEstado === this.ESTADOS_TERMINADO));
    this.dataSourceTerminado.paginator = this.paginatorTerminado;
  }
  HabilitarOpcionesEdicion(): boolean {
    return this.menuService.TienePermisoEscrituraEnMenu('ExpedientesComponent');
  }
  CantidadExpedientesNuevos(): number {
    if (this.listaDatos) {
      return this.listaDatos.filter(x => x.codigoEstado === this.ESTADOS_NUEVO).length;
    }
    return 0;
  }
  CantidadExpedientesProceso(): number {
    if (this.listaDatos) {
      return this.listaDatos.filter(x => x.codigoEstado === this.ESTADOS_PROCESO).length;
    }
    return 0;
  }
  CantidadExpedientesSeguimiento(): number {
    if (this.listaDatos) {
      return this.listaDatos.filter(x => x.codigoEstado === this.ESTADOS_SEGUIMIENTO).length;
    }
    return 0;
  }
  CantidadExpedientesTerminado(): number {
    if (this.listaDatos) {
      return this.listaDatos.filter(x => x.codigoEstado === this.ESTADOS_TERMINADO).length;
    }
    return 0;
  }
  ClicPaginacion(e: any) {
    e.stopPropagation();
  }
  IconoValorPorcentaje(porcentaje: number): string {
    if (porcentaje < 0) {
      return 'iconorojo';
    } else if (porcentaje === 0) {
      return 'iconoamarillo';
    } else {
      return 'iconoverde';
    }
  }
  TipoIconoValorPorcentaje(porcentaje: number): string {
    if (porcentaje < 0) {
      return 'expand_more';
    } else if (porcentaje === 0) {
      return 'minimize';
    } else {
      return 'expand_less';
    }
  }
  ClaseValorPorcentaje(porcentaje: number): string {
    if (porcentaje < 0) {
      return 'contenedorrojo';
    } else if (porcentaje === 0) {
      return 'contenedoramarillo';
    } else {
      return 'contenedorverde';
    }
  }
  AbrirDetalle(itemSeleccionado: Expedientes_Lista) {
    this.menuService.CambiarComponenteActivo('ExpedientesDetalleComponent', itemSeleccionado.codigoExpediente);
  }
  CambiarExpanderNuevo() {
    this.mostrarExpedientesNuevos = !this.mostrarExpedientesNuevos;
  }
  CambiarExpanderProceso() {
    this.mostrarExpedientesProceso = !this.mostrarExpedientesProceso;
  }
  CambiarExpanderSeguimiento() {
    this.mostrarExpedientesSeguimiento = !this.mostrarExpedientesSeguimiento;
  }
  CambiarExpanderTerminado() {
    this.mostrarExpedientesTerminado = !this.mostrarExpedientesTerminado;
  }
}
